import { render, staticRenderFns } from "./priceExchange.vue?vue&type=template&id=07c5418d&scoped=true&"
import script from "./priceExchange.vue?vue&type=script&lang=js&"
export * from "./priceExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5418d",
  null
  
)

export default component.exports